import BaseApiService from './api.base.service'

class SubscriptionsApiService extends BaseApiService {
  constructor() {
    super('subscriptions')
  }

  getActivePurchasableSubscriptionsOdata(params) {
    return this.callGet(`/ecpass/active/purchasable/odata`, params)
  }

  getActiveSubscriptionWithPartecipationRequestToBeCompletedOdata(params) {
    return this.callGet(`ecpass/request-not-completed/active/odata`, params)
  }

  getSubscriptionRelatedDocuments(subscriptionId, subscriptioMacroCategory) {
    return this.callPost(`ecpass/documents`, {
      subscriptionId,
      subscriptioMacroCategory,
    })
  }

  getActiveEvolutionSubscriptions() {
    return this.callGet(`/evolution/active`)
  }

  getActiveEvolutionSubscriptionsOdata(params) {
    return this.callGet(`/evolution/active/odata`, params)
  }
  getActiveEvolutionSubscriptionsAggregatedOdata(params) {
    return this.callGet(`/evolution/active/aggregated-odata`, params)
  }

  getActiveEvolutionSubscriptionUrl(rowId, activationFrom) {
    return this.callPost('/evolution/active/url', {
      rowId,
      activationFrom,
    })
  }

  updateEcBlogSubscription(emailActivation) {
    return this.callPost('ec-blog-subscription', {
      tsId: emailActivation.tsId,
      emailActivationId: emailActivation.emailActivationId,
    })
  }

  isTSSEcBlogSubscriptionAlreadyEnabled(tsId) {
    return this.callPost('ec-blog-subscription/active', tsId)
  }
}

export const subscriptionsApi = new SubscriptionsApiService()
